import { Compass } from 'lucide-react'
import { SiteLayout } from '../components/ui/site-chrome'
import { TrustPage } from '../components/ui/trust-page'

export default function FractionalCtoPage() {
  return (
    <SiteLayout
      current="/fractional-cto"
      title="Fractional CTO Services | Zadro"
      description="Fractional CTO services for founders and teams that need technical leadership, architecture review, hiring guidance, and execution clarity."
    >
      <TrustPage
        Icon={Compass}
        visual="cto"
        eyebrow="Fractional CTO"
        heroTitle="Technical leadership for founders who need a map before more motion."
        heroCopy="A fractional CTO gives you senior technical judgment without the full-time executive overhead. I help translate business strategy into architecture, roadmap, team rhythm, vendor decisions, and delivery discipline."
        proof={[
          '17+ years across e-commerce, startups, real estate technology, and cloud systems.',
          'Built to translate between founders, engineers, vendors, and executive stakeholders.',
          'Designed for non-technical founders and technical teams that need objective leadership.',
        ]}
        cards={[
          {
            title: 'Founder clarity',
            copy: 'Turn vague technical anxiety into decisions: what to build, what to buy, what to pause, and where the team needs help.',
          },
          {
            title: 'Team operating rhythm',
            copy: 'Create better rituals, ownership, review loops, and prioritization so engineering effort becomes business value faster.',
          },
          {
            title: 'Architecture judgment',
            copy: 'Review the stack, roadmap, risks, and delivery path before expensive technical decisions become irreversible.',
          },
        ]}
        sections={[
          {
            kicker: 'What I Diagnose',
            title: 'The hidden constraints behind slow execution.',
            copy: 'Most teams do not need more tickets. They need a clearer circuit: business intent, technical translation, ownership, and feedback.',
            items: [
              'Roadmaps that keep changing because the real constraint was never named',
              'Engineering teams shipping work that does not move the business metric',
              'Vendors or agencies that are hard to manage because no one owns technical truth',
              'Architecture choices that make the next product move slower than it should be',
            ],
          },
          {
            kicker: 'Engagement Shape',
            title: 'A practical CTO layer that can flex with the company.',
            copy: 'The work can start as an audit, become a monthly leadership layer, or expand into a transformation engagement when the company is ready.',
            items: [
              'Executive advisory and founder coaching',
              'Roadmap and architecture reviews',
              'Hiring, team design, vendor review, and delivery cadence',
              'Technical strategy for AI, data, SaaS, marketplaces, and internal platforms',
            ],
          },
        ]}
      />
    </SiteLayout>
  )
}
